import React, { useCallback, useContext, useMemo } from 'react';
import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import { AppointmentTooltipContextProvider } from '../../AppointmentTooltipContext';
import { SchedulerContext } from '../../SchedulerContext';
import { ActiveDatabaseContext } from '../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  hasRutinKod,
  isReadOnlyRutin,
} from '../../../../../ObjektVyer/Aktivitet/Utils/AktivitetUtils';
import { useQuery } from '@apollo/client';
import {
  MeQuery,
  MeQueryVariables,
} from '../../../Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../../../Queries/MeQuery/MeQuery.gql';
import EDIconButton from '../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { makeStyles } from 'tss-react/mui';
import { useIsSmallScreen } from '../../../../../../../../Hooks/useFullscreenView';

const useStyles = makeStyles<{}>()(() => ({
  customPointerHandler: {
    '& .MuiPaper-root': {
      pointerEvents: 'auto',
    },
    pointerEvents: 'none',
  },
}));

export const TooltipLayoutComponent = (
  props: AppointmentTooltip.LayoutProps
) => {
  const actionRef = React.useRef(null);
  const schedulerContext = React.useContext(SchedulerContext);
  const onSelectDetail = schedulerContext.onSelectDetail;
  const databaseContext = useContext(ActiveDatabaseContext);
  const availableRoutines = databaseContext.availableRoutines;
  const isSmallScreen = useIsSmallScreen();
  const { classes } = useStyles({});
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const activeDatabaseOptions = useMemo(
    () => ({
      variables: {
        dbname: activeDatabase ?? 'noDBYet',
      },
      skip: !activeDatabase,
    }),
    [activeDatabase]
  );
  const { data: me_data } = useQuery<MeQuery, MeQueryVariables>(
    meQuery,
    activeDatabaseOptions
  );

  const canEditBooking =
    me_data?.me?.[0]?.userCanEditBooking ||
    props.appointmentMeta?.data.bokningssignatur === me_data?.me?.[0]?.sign;

  const onOpenButtonClick = useCallback(() => {
    onSelectDetail?.({
      id: props.appointmentMeta?.data.activityId ?? '',
      data: props.appointmentMeta?.data.activity,
    });
  }, [props.appointmentMeta?.data, onSelectDetail]);
  //↓↓ check that the cell is not a day name cell before rendering the tooltip ↓↓

  const onMouseLeave = () => {
    schedulerContext.tooltipOnHover(true);
  };

  const onCloseButtonClick = () => {
    schedulerContext.tooltipOnHover(true);
  };

  if (!props.appointmentMeta?.data.dayName) {
    return (
      <AppointmentTooltipContextProvider actions={actionRef}>
        <AppointmentTooltip.Layout
          {...props}
          action={actionRef}
          onOpenButtonClick={onOpenButtonClick}
          showOpenButton={
            props.appointmentMeta?.data.aktivityType !== 'OUTLOOK'
          }
          commandButtonComponent={id => {
            return (canEditBooking &&
              hasRutinKod('rtnWebKalender', availableRoutines) &&
              !isReadOnlyRutin('rtnWebKalender', availableRoutines) &&
              props.appointmentMeta?.data.aktivityType === 'AKTOVRIGT') ||
              (canEditBooking &&
                hasRutinKod('rtnWebBokaGudstjanst', availableRoutines) &&
                !isReadOnlyRutin('rtnWebBokaGudstjanst', availableRoutines) &&
                hasRutinKod('rtnWebKalender', availableRoutines) &&
                !isReadOnlyRutin('rtnWebKalender', availableRoutines) &&
                props.appointmentMeta?.data.aktivityType === 'GUDSTJANST') ? (
              <>
                <EDIconButton
                  sx={{
                    padding: isSmallScreen ? '0px' : '8px',
                    marginRight: isSmallScreen ? '0px' : '8px',
                  }}
                  icon={'edit'}
                  tooltip={'Redigera'}
                  onClick={() => {
                    onOpenButtonClick();
                  }}
                  iconSize={isSmallScreen ? 'medium' : 'default'}
                ></EDIconButton>
                {isSmallScreen && (
                  <EDIconButton
                    icon={'close'}
                    tooltip={'Stäng'}
                    onClick={() => {
                      onCloseButtonClick();
                    }}
                    iconSize={isSmallScreen ? 'medium' : 'default'}
                  ></EDIconButton>
                )}
              </>
            ) : (
              <>
                <EDIconButton
                  sx={{ padding: isSmallScreen ? '0px' : '8px' }}
                  icon={'info'}
                  tooltip={'Öppna'}
                  onClick={() => {
                    onOpenButtonClick();
                  }}
                  iconSize={isSmallScreen ? 'medium' : 'default'}
                ></EDIconButton>
                {isSmallScreen && (
                  <EDIconButton
                    sx={{ padding: '0px' }}
                    icon={'close'}
                    tooltip={'Stäng'}
                    onClick={() => {
                      onCloseButtonClick();
                    }}
                    iconSize={isSmallScreen ? 'medium' : 'default'}
                  ></EDIconButton>
                )}
              </>
            );
          }}
          className={classes.customPointerHandler}
          onMouseLeave={onMouseLeave}
        />
      </AppointmentTooltipContextProvider>
    );
  } else return null;
};
